<template>

  <div class="card">
    <div class="card-header pt-3">
      <h5><strong>Empresas deste usuário</strong></h5>
    </div>

    <div class="card-body">
      <p v-if="usesPermissionGroups" class="small text-muted mb-0">
        Empresas liberadas pelos grupos de permissão desta pessoa. Para mudar, edite o grupo ou troque o grupo
        pelo botão Editar.
      </p>
      <div class="row" v-else-if="$withPolicy()">
        <div class="col-md-12">
          <button @click="showModal = true" class="btn btn-primary btn-lg">
            Vincular empresa
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">

          <table class="table table-borderless table-border table-align table-h51">
            <thead>
              <tr>
                <th>Razão Social</th>
                <th>CNPJ</th>
                <th>IE</th>
                <th>UF</th>
                <th>E-mail</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="company in companies" :key="company.id">
                <td>{{ company.name }}.</td>
                <td>{{ company.cnpj | cnpj }}</td>
                <td>{{ company.im }}</td>
                <td>{{ company.uf }}</td>
                <td>{{ company.email }}</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-md-12 my-1">
              <Pagination
                v-model="meta.currentPage"
                :total-count="meta.totalCount"
                :total-pages="meta.totalPages"
                @pagination="pagination"
              />
            </div>
          </div>

        </div>
      </div>
    </div>

    <Modal v-model="showModal">
      <span slot="header">
        Vincular empresa ao usuário
      </span>

      <Select2 v-model="cnpjs" :options="optionsCompanies"/>

      <template slot="footer">
        <button @click="showModal=false" class="btn btn-outline btn-lg">Cancelar</button>
        <button @click="updateCompanies" class="btn btn-primary btn-lg">Salvar</button>
      </template>

    </Modal>

  </div>

</template>

<script>
  import Formatter from '@/models/Formatter'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Modal from '@/components/shares/specialTag/Modal'
  import Select2 from '@/components/shares/Select2'

  export default {
    components: { Modal, Pagination, Select2 },
    computed: {
      companies() {
        return this.getModels || []
      },
      usesPermissionGroups() {
        return this.$store.getters.usesPermissionGroups
      }
    },
    created() {
      this.query.userId = this.user.id
      this.query.type = ['parent', 'subsidiary']
      this.cnpjs = this.user.accountUser.cnpjs || []

      this.asyncTemplateSelect({
        before: async () => {
          await this.findAllCompanies()
        }
      })
    },
    data() {
      return {
        cnpjs: [],
        keyModel: 'userCompanies',
        nameModel: 'Company',
        optionsCompanies: [],
        showModal: false
      }
    },
    methods: {
      async findAllCompanies() {
        const params = {
          per_page: 1000,
          q: { type: ['parent', 'subsidiary'] }
        }
        const response = await this.axios.get('companies', { params: params })
        this.optionsCompanies = response.data.map(c => {
          return {
            label: `${c.name} - ${Formatter.cnpj(c.cnpj)}`,
            value: c.cnpj
          }
        })
      },
      updateCompanies() {
        let cnpjs = this.cnpjs

        this.openLoad()
        this.axios.put(`users/${this.user.id}`, { cnpjs: cnpjs })
          .then(() => this.showModal = false)
          .then(() => this.user.cnpjs = cnpjs)
          .then(() => this.cnpjs = cnpjs)
          .then(() => this.asyncTemplateSelect())
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      }
    },
    mixins: [ModelMapper],
    name: 'CardCompanies',
    props: {
      user: { required: true, type: Object }
    }
  }
</script>

<style scoped>

</style>
